import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ContainerVisitService } from '@common/services/container-visit.service';
import { ModalService } from '@common/services/modal.service';
import { marker } from '@common/translate-marker';
import { TranslateService } from '@ngx-translate/core';
import { DialogCloseResult, DialogRef } from '@progress/kendo-angular-dialog';
import { ToastService } from '@services/toast.service';
import { CancelMovesDisplayModel } from 'app/cargo-operations/models/CancelMoves.display.model';
import { filter } from 'rxjs';

@Component({
    selector: 'app-cancel-moves-modal',
    templateUrl: './cancel-moves-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CancelMovesModalComponent implements OnInit {
    title: string;
    message: string;
    manipulation: string;
    containerItemIds: any[];
    serviceRequestId: string;

    model: CancelMovesDisplayModel = new CancelMovesDisplayModel();
    form: UntypedFormGroup;

    constructor(
        public activeModal: DialogRef,
        private dialogService: ModalService,
        private translateService: TranslateService,
        private toastyService: ToastService,
        private service: ContainerVisitService
    ) {}

    ngOnInit() {
        this.form = this.model.createFormGroup();
        this.form.get('containerCount').patchValue(this.containerItemIds.length);
        this.form.get('serviceRequestId').patchValue(this.serviceRequestId);
        this.form.get('manipulation').patchValue(this.manipulation);
    }

    clear(data: any) {
        this.form.reset();
    }

    save() {
        this.dialogService
            .confirm(
                this.translateService.instant(marker('Cancel selected containers?')),
                this.translateService.instant(marker('Are you sure you want to remove selected containers?')),
                this.translateService.instant(marker('YES')),
                null,
                this.translateService.instant(marker('No'))
            )
            .pipe(filter((x) => !(x instanceof DialogCloseResult)))
            .subscribe((dialogResult) => {
                if (dialogResult) {
                    const body = {
                        cancelRemark: this.form.get('cancelRemark').value,
                        versionContainerIds: this.containerItemIds
                    };
                    this.service
                        .cancelContainerMove(body)
                        .pipe()
                        .subscribe({
                            next: () => {
                                this.activeModal.close(body);
                            }
                        });
                }
            });
    }
}
